import createConverter from './lib/create_converter';
import CustomerMerge from 'models/customer_merge';

export default createConverter(CustomerMerge);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/customer_merge_converter.js